/**
 * OperationalLineageGraphLegend
 *
 * Compact semantic legend showing node types and edge semantics.
 * Uses operationalVisualLanguage tokens exclusively.
 */

import React from 'react';
import { NEUTRAL, TYPOGRAPHY, SPACING } from '../../../modules/governanceEventStream/operationalVisualLanguage/index.js';

const NODE_LEGEND = [
  { shape: '◆', label: 'event stream', color: '#506888' },
  { shape: '■', label: 'projection', color: '#9a9aaa' },
  { shape: '▪', label: 'pane model', color: '#7a7a88' },
  { shape: '●', label: 'continuity', color: '#3d7a3d' },
  { shape: '◈', label: 'replay window', color: '#4868a0' },
  { shape: '◆', label: 'bundle', color: '#c0c0d0' },
  { shape: '◉', label: 'attestation', color: '#509050' },
  { shape: '◎', label: 'verifier', color: '#3d7a3d' },
];

const EDGE_LEGEND = [
  { style: 'solid', label: 'produced / derived', color: '#7a7a88' },
  { style: 'solid-thick', label: 'verified / signed', color: '#3d7a3d' },
  { style: 'dashed', label: 'replay', color: '#4868a0' },
  { style: 'dashed-animated', label: 'continuity', color: '#c8860a' },
  { style: 'dotted', label: 'hash bound', color: '#55555f' },
];

export const OperationalLineageGraphLegend: React.FC = () => {
  return (
    <div
      style={{
        backgroundColor: NEUTRAL.bg200,
        border: `1px solid ${NEUTRAL.borderSubtle}`,
        borderRadius: 3,
        padding: `${SPACING.sp2}px ${SPACING.sp3}px`,
        fontSize: TYPOGRAPHY.micro.size,
        fontFamily: 'system-ui, sans-serif',
        color: NEUTRAL.text400,
        maxWidth: 180,
      }}
      data-testid="lineage-graph-legend"
    >
      <div style={{ fontWeight: 600, color: NEUTRAL.text500, marginBottom: SPACING.sp2, fontSize: TYPOGRAPHY.label.size }}>
        Nodes
      </div>
      {NODE_LEGEND.map((item) => (
        <div key={item.label} style={{ display: 'flex', alignItems: 'center', gap: SPACING.sp2, marginBottom: 2 }}>
          <span style={{ color: item.color, fontFamily: 'monospace', fontSize: 9, width: 14, textAlign: 'center' }}>
            {item.shape}
          </span>
          <span>{item.label}</span>
        </div>
      ))}
      <div style={{ fontWeight: 600, color: NEUTRAL.text500, marginTop: SPACING.sp3, marginBottom: SPACING.sp2, fontSize: TYPOGRAPHY.label.size }}>
        Edges
      </div>
      {EDGE_LEGEND.map((item) => {
        const borderStyle = item.style === 'dotted' ? 'dotted' : item.style === 'dashed' || item.style === 'dashed-animated' ? 'dashed' : 'solid';
        const borderWidth = item.style === 'solid-thick' ? 2 : 1;
        return (
          <div key={item.label} style={{ display: 'flex', alignItems: 'center', gap: SPACING.sp2, marginBottom: 2 }}>
            <span
              style={{
                width: 14,
                height: 0,
                borderTop: `${borderWidth}px ${borderStyle} ${item.color}`,
                display: 'inline-block',
              }}
            />
            <span>{item.label}</span>
          </div>
        );
      })}
    </div>
  );
};
